import React, { useCallback, useEffect, useState } from 'react';

import themeConfig from 'configs/themeConfig';

export const ContextLayout = React.createContext();

export const LayoutContextProvider = ({ children }) => {
  const [activeLayout, setActiveLayout] = useState(themeConfig.layout);
  const [width, setWidth] = useState(window?.innerWidth);
  const [direction, setDirection] = useState(themeConfig.direction);

  const handleWindowResize = useCallback(() => {
    setWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    if (direction === 'rtl') document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    else document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
  }, [direction]);

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [handleWindowResize]);

  return (
    <ContextLayout.Provider
      value={{
        state: {
          activeLayout,
          direction,
          width,
        },
        switchLayout: setActiveLayout,
        switchDir: setDirection,
      }}
    >
      {children}
    </ContextLayout.Provider>
  );
};
